import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES, buildCampaignWizardPath } from "../utils/campaignWizardNavigation";
import { trackCtaClicked, trackFeatureStarted } from "../analytics/analytics";
import {
    ANALYTICS_CTAS,
    ANALYTICS_FEATURES,
    ANALYTICS_ENTRY_POINTS,
} from "../analytics/analytics.constants";
import CreateContentTypeModal from "./dashboard/CreateContentTypeModal";
import "bootstrap-icons/font/bootstrap-icons.css";

/**
 * Orange + control that opens the create-type modal, then fast-forwards into the campaign wizard.
 */
export default function CreateContentButton({
    className = "",
    entryPoint = ANALYTICS_ENTRY_POINTS.SIDEBAR,
}) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        trackCtaClicked(ANALYTICS_CTAS.CREATE_FIRST_POST);
        trackFeatureStarted(ANALYTICS_FEATURES.CAMPAIGN_BUILDER, {
            entry_point: entryPoint,
        });
        setOpen(true);
    };

    const handleContinue = (contentType) => {
        setOpen(false);
        navigate(
            buildCampaignWizardPath(APP_ROUTES.HOME, null, {
                fastForward: true,
                assetType: contentType?.assetType ?? null,
            })
        );
    };

    return (
        <>
            <button
                type="button"
                onClick={handleOpen}
                className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-orange-900 bg-orange-700 text-white shadow-sm transition hover:bg-orange-800 active:scale-95 ${className}`}
                aria-label="Create content"
                title="Create"
            >
                <i className="bi bi-plus-lg text-lg leading-none" aria-hidden />
            </button>
            <CreateContentTypeModal
                open={open}
                onClose={() => setOpen(false)}
                onContinue={handleContinue}
            />
        </>
    );
}
